import { getRequest, postRequest, printRequest } from  './utils';
import { captureError } from './sentry';

export async function getMemberRewardInitialData() {

  try {
    const result = await getRequest('/memberreward/getlists');
    return result;
  } catch (error) {
    // Capturar el error en Sentry antes de relanzarlo
    captureError(error, { function: 'getMemberRewardInitialData' });
    throw new Error(`Error en getMemberRewardInitialData: ${error.message}`);
  }
}

export async function createMemberRewardClaim(index, params) {
  try {
    const result = await postRequest('MemberReward/createclaim', null, params);
    return result;
  } catch (error) {
    // Capturar el error en Sentry antes de relanzarlo
    captureError(error, { function: 'createMemberRewardClaim' });
    throw new Error(`Error en createMemberRewardClaim: ${error.message}`);
  }
}

/**
 * Member Resources
 */

export async function getMemberResourcesInitialData() {
  try {
    const result = await getRequest('MemberResources/getlists/true');
    return result;
  } catch (error) {
    // Capturar el error en Sentry antes de relanzarlo
    captureError(error, { function: 'getMemberResourcesInitialData' });
    throw new Error(`Error en getMemberResourcesInitialData: ${error.message}`);
  }
}

export async function postMemberResourcesListData(params) {
  try {
    const result = await postRequest('MemberResources/getplandocuments', null, params);
    return result;
  } catch (error) {
    // Capturar el error en Sentry antes de relanzarlo
    captureError(error, { function: 'postMemberResourcesListData' });
    throw new Error(`Error en postMemberResourcesListData: ${error.message}`);
  }
}

/**
 * Find a Provider
 */

export async function getFindAProviderInitialData() {
  try {
    const result = await getRequest('FindProvider/getlists');
    return result;
  } catch (error) {
    // Capturar el error en Sentry antes de relanzarlo
    captureError(error, { function: 'getFindAProviderInitialData' });
    throw new Error(`Error en getFindAProviderInitialData: ${error.message}`);
  }
}

export async function getProviderData(id) {
  try {
    const result = await getRequest(`FindProvider/getitem/${id}`);
    return result;
  } catch (error) {
    // Capturar el error en Sentry antes de relanzarlo
    captureError(error, { function: 'getProviderData' });
    throw new Error(`Error en getProviderData: ${error.message}`);
  }
}

export async function postFindAProviderListData(params) {
  try {
    const result = await postRequest('FindProvider/search', null, params);
    return result;
  } catch (error) {
    // Capturar el error en Sentry antes de relanzarlo
    captureError(error, { function: 'postFindAProviderListData' });
    throw new Error(`Error en postFindAProviderListData: ${error.message}`);
  }
}

export async function postFindAProviderPrint(params) {
  try {
    const result = await printRequest('FindProvider/print', null, params);
    return result;
  } catch (error) {
    // Capturar el error en Sentry antes de relanzarlo
    captureError(error, { function: 'postFindAProviderPrint' });
    throw new Error(`Error en postFindAProviderPrint: ${error.message}`);
  }
}

/**
 * Find a Provider
 */

export async function getMemberPlanSearchYears() {
  try {
    const result = await getRequest('Enrollment/getyears/true');
    return result;
  } catch (error) {
    // Capturar el error en Sentry antes de relanzarlo
    captureError(error, { function: 'getMemberPlanSearchYears' });
    throw new Error(`Error en getMemberPlanSearchYears: ${error.message}`);
  }
}

export async function getMemberPlanSearchCounties(id) {
  try {
    const result = await getRequest(`Enrollment/getcounties/${id}`);
    return result;
  } catch (error) {
    // Capturar el error en Sentry antes de relanzarlo
    captureError(error, { function: 'getMemberPlanSearchCounties' });
    throw new Error(`Error en getMemberPlanSearchCounties: ${error.message}`);
  }
}

/**
 * Member Enrollment
 */

export async function postMemberEnrollment(params) {
  try {
    const result = await postRequest('Enrollment/createapp', null, params);
    return result;
  } catch (error) {
    // Capturar el error en Sentry antes de relanzarlo
    captureError(error, { function: 'postMemberEnrollment' });
    throw new Error(`Error en postMemberEnrollment: ${error.message}`);
  }
}